import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isTokenValid } from "../Utils/auth";

const ProtectedRoute = ({ children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isTokenValid() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
